import { Toaster as Sonner } from "sonner";
import "./sonner.css";

const Toaster = ({ ...props }) => {
  return (
    <Sonner
      theme="dark"
      className="toaster group"
      toastOptions={{
        classNames: {
          toast: "sonner-toast group-toast",
          description: "sonner-description",
          actionButton: "sonner-action",
          cancelButton: "sonner-cancel",
        },
      }}
      {...props}
    />
  );
};

export { Toaster };

